export const FETCH_ALL_COUNTRIES = 'FETCH_ALL_COUNTRIES';
export const FETCH_COUNTRY = 'FETCH_COUNTRY';
export const CREATE_COUNTRY = 'CREATE_COUNTRY';
export const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
export const REMOVE_COUNTRY = 'REMOVE_COUNTRY';